export default "__VITE_ASSET__BElSj_C6__"